import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import PropTypes from 'prop-types';
import React from 'react';
import { Image, Text, TouchableOpacity, View, StyleSheet } from 'react-native';
import Color from './Color';
var carrot = Color.carrot,
    emerald = Color.emerald,
    peterRiver = Color.peterRiver,
    wisteria = Color.wisteria,
    alizarin = Color.alizarin,
    turquoise = Color.turquoise,
    midnightBlue = Color.midnightBlue;
var styles = StyleSheet.create({
  avatarStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 40,
    height: 40,
    borderRadius: 20
  },
  avatarTransparent: {
    backgroundColor: Color.backgroundTransparent
  },
  textStyle: {
    color: Color.white,
    fontSize: 16,
    backgroundColor: Color.backgroundTransparent,
    fontWeight: '100'
  }
});

var GiftedAvatar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GiftedAvatar, _React$Component);

  function GiftedAvatar() {
    var _this;

    _classCallCheck(this, GiftedAvatar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GiftedAvatar).apply(this, arguments));
    _this.avatarName = undefined;
    _this.avatarColor = undefined;

    _this.handleOnPress = function () {
      var _this$props = _this.props,
          onPress = _this$props.onPress,
          other = _objectWithoutProperties(_this$props, ["onPress"]);

      if (_this.props.onPress) {
        _this.props.onPress(other);
      }
    };

    _this.handleOnLongPress = function () {};

    return _this;
  }

  _createClass(GiftedAvatar, [{
    key: "setAvatarColor",
    value: function setAvatarColor() {
      var userName = this.props.user && this.props.user.name || '';
      var name = userName.toUpperCase().split(' ');

      if (name.length === 1) {
        this.avatarName = "".concat(name[0].charAt(0));
      } else if (name.length > 1) {
        this.avatarName = "".concat(name[0].charAt(0)).concat(name[1].charAt(0));
      } else {
        this.avatarName = '';
      }

      var sumChars = 0;

      for (var _i = 0; _i < userName.length; _i += 1) {
        sumChars += userName.charCodeAt(_i);
      } // inspired by https://github.com/wbinnssmith/react-user-avatar
      // colors from https://flatuicolors.com/


      var colors = [carrot, emerald, peterRiver, wisteria, alizarin, turquoise, midnightBlue];
      this.avatarColor = colors[sumChars % colors.length];
    }
  }, {
    key: "renderAvatar",
    value: function renderAvatar() {
      var user = this.props.user;

      if (user) {
        if (typeof user.avatar === 'function') {
          return user.avatar([styles.avatarStyle, this.props.avatarStyle]);
        } else if (typeof user.avatar === 'string') {
          return React.createElement(Image, {
            source: {
              uri: user.avatar
            },
            style: [styles.avatarStyle, this.props.avatarStyle]
          });
        } else if (typeof user.avatar === 'number') {
          return React.createElement(Image, {
            source: user.avatar,
            style: [styles.avatarStyle, this.props.avatarStyle]
          });
        }
      }

      return null;
    }
  }, {
    key: "renderInitials",
    value: function renderInitials() {
      return React.createElement(Text, {
        style: [styles.textStyle, this.props.textStyle]
      }, this.avatarName);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.user || !this.props.user.name && !this.props.user.avatar) {
        // render placeholder
        return React.createElement(View, {
          style: [styles.avatarStyle, styles.avatarTransparent, this.props.avatarStyle],
          accessibilityTraits: "image"
        });
      }

      if (this.props.user.avatar) {
        return React.createElement(TouchableOpacity, {
          disabled: !this.props.onPress,
          onPress: this.props.onPress,
          onLongPress: this.props.onLongPress,
          accessibilityTraits: "image"
        }, this.renderAvatar());
      }

      this.setAvatarColor();
      return React.createElement(TouchableOpacity, {
        disabled: !this.props.onPress,
        onPress: this.props.onPress,
        onLongPress: this.props.onLongPress,
        style: [styles.avatarStyle, {
          backgroundColor: this.avatarColor
        }, this.props.avatarStyle],
        accessibilityTraits: "image"
      }, this.renderInitials());
    }
  }]);

  return GiftedAvatar;
}(React.Component);

export { GiftedAvatar as default };
GiftedAvatar.defaultProps = {
  user: {
    name: null,
    avatar: null
  },
  onPress: null,
  avatarStyle: {},
  textStyle: {}
};
GiftedAvatar.propTypes = {
  user: PropTypes.object,
  onPress: PropTypes.func
};